import type { SxStyle } from '@aibees/shared/theme';

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  p: (p) => p.spacing(1),
  // background: (p) => p.palette.grey[200],
};

export const slider: SxStyle = {
  '.slick-track': { width: '100% !important' },
  '.slick-slide': { width: '100% !important' },
};
